import {Extension} from '@tiptap/core'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    obvioVariable: {
      insertObvioVariable: (value: string) => ReturnType
    }
  }
}

const ObvioVariable = Extension.create({
  name: 'obvioVariable',

  addCommands() {
    return {
      insertObvioVariable: (value: string) => ({commands}) => {
        return commands.insertContent(value)
      },
    }
  },
})

export default ObvioVariable
